/**
 * The same as `[...iterable].toSorted(cmp)[0]`
 * but with O(n) time complexity.
 */
export function minByComparator<T> (iterable: Iterable<T>, cmp: (a: T, b: T) => number): T | undefined {
  let visitedOneElement = false
  let minimum: T | undefined = undefined
  for (const x of iterable) {
    if (visitedOneElement) {
      if (cmp(x, minimum!) < 0) {
        minimum = x
      }
    } else {
      minimum = x
      visitedOneElement = true
    }
  }

  return minimum
}
